<template>
  <div style="background-color: #f5f5f5;">
    <Topo />
    <b-container>
      <h3 class="mb-4 text-center"><b><u>Status da Inscrição</u></b></h3>
      <div class="row">
        <div class="col-md-3 mb-3">
          <Menu />
        </div>
        <div class="col-md-9">
          <b-card header="Transações" class="mb-3">

            <div v-for="c in compras" v-bind:key="c.id" class="container" style="margin-bottom: 1.5rem; font-size: 0.85rem; border: 2px solid #ccc;">
              <div class="row">
                <div class="col-md-4 pl-0 pr-0">
                  <table class="table table-bordered mb-0">
                    <tr>
                      <th colspan="2" class="text-center bg-primary text-white">
                        DADOS DA TRANSAÇÃO
                      </th>
                    </tr>
                    <tr>
                      <td class="negrito">Nr. Transação:</td>
                      <td>{{ ('00000000' + c.id).slice(-8) }}</td>
                    </tr>
                    <tr>
                      <td class="negrito">Data da Compra:</td>
                      <td>{{ c.data_compra }}</td>
                    </tr>
                    <tr>
                      <td class="negrito">Forma de Pagamento:</td>
                      <td>{{ c.forma_de_pagamento }}</td>
                    </tr>
                    <tr>
                      <td class="negrito">Situação:</td>
                      <td>{{ c.situacao }}</td>
                    </tr>
                    <tr>
                      <td class="negrito">Valor Total:</td>
                      <td nowrap>{{ FormatPrice(c.total) }}</td>
                    </tr>
                  </table>
                </div>
                <div class="col-md-8 pl-0 pr-0">
                  <Atividades :id_compra="c.id" />
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 text-center pt-2 pb-2">
                  <b-button v-if="c.situacao==='Em aberto'" @click="GerarBoleto(c.id, c.vencido)" size="sm" variant="success">
                    <span v-if="!trabalhando">Gerar Boleto</span>
                    <span v-else><b-spinner small class="mr-2"></b-spinner>Trabalhando...</span>
                  </b-button>
                </div>
              </div>
            </div>
          </b-card>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>

import { baseApiUrl, showError } from '@/global'
import { mapState } from 'vuex'
import axios from 'axios'
import Topo from '@/components/Topo.vue'
import Menu from '@/components/Menu.vue'
import Atividades from '@/components/Atividades.vue'

export default {
  name: 'Status',
  computed: mapState(['user']),
  components: { Topo, Menu, Atividades },
  data: function () {
    return {
      trabalhando: false,
      dados_participante: {},
      dados_boleto: {},
      compras: [],
      dataAtual: this.$moment().subtract(3, 'hours'),
      dataFinal: this.$moment('2020-10-05 23:59:00') // .format('DD/MM/YYYY')
    }
  },
  methods: {
    CarregaDados () {
      const url = `${baseApiUrl}/ficha/pega_status/${this.user.id}`
      axios.get(url).then(res => {
        this.compras = res.data
      })
        .catch(err => {
          showError(err)
        })
    },
    GerarBoleto (VarIDCompra, Vencido) {
      this.trabalhando = true
      if (!Vencido) {
        this.BuscaDadosBoleto(VarIDCompra)
      } else {
        this.GeraNovaCompra(VarIDCompra)
      }
    },
    BuscaDadosBoleto (VarIDCompra) {
      const url = `${baseApiUrl}/busca_url_boleto/${VarIDCompra}`
      axios.get(url)
        .then(res => {
          window.open(res.data.url_bradesco)
          this.trabalhando = false
        })
        .catch(err => {
          showError(err)
          this.trabalhando = false
        })
    },
    CadastraCompranoBradesco (VarIDNovaCompra) {
      const url = `${baseApiUrl}/pega_dados_para_boleto_status/${VarIDNovaCompra}`
      axios.get(url)
        .then(res => {
          this.dados_participante = res.data
          this.RegistraCompranoBradesco(this.dados_participante)
        })
        .catch(err => {
          showError(err)
        })
    },
    GeraNovaCompra (VarIDCompra) {
      const url = `${baseApiUrl}/ficha/atualiza_compra/${this.user.id_categoria}/${VarIDCompra}`
      axios.post(url)
        .then(res => {
          // console.log(res)
          this.CadastraCompranoBradesco(res.data)
          // this.BuscaDadosBoleto(res.data)
          this.CarregaDados()
        })
        .catch(err => {
          showError(err)
        })
    },
    RegistraCompranoBradesco (DadosPart) {
      axios.post(`${baseApiUrl}/bradesco`, DadosPart)
        .then(res => {
          if (Object.keys(res.data).length !== 0) {
            const urlboleto = {
              url_bradesco: res.data.boleto.urlAcesso
            }
            axios.put(`${baseApiUrl}/salva_url_boleto/${DadosPart.id_compra}`, urlboleto)
              .then(() => {})
              .catch(err => { showError(err) })
          }
          this.dados_boleto = res.data
          window.open(res.data.boleto.urlAcesso)
          this.trabalhando = false
        })
        .catch(err => {
          showError(err)
        })
    },
    FormatPrice (value) {
      const val = (value / 1).toFixed(2).replace('.', ',')
      return 'R$ ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    }
  },
  mounted () {
    this.CarregaDados()
  }
}
</script>

<style>
  .negrito {
    font-weight: bold !important;
  }
  .bg_grey2 {
    background-color: rgb(102, 109, 125) !important;
    color: #fff !important;
  }
</style>
